import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_LATEST_DELIVERY_NOTES } from './gql/getLatestDeliveryNotes';

type QueryDataType = Pick<Query, 'getLatestDeliveryNotes'>;

type OutgoingDataType = QueryDataType['getLatestDeliveryNotes'];

const onError = getErrorLoggerFunction('getLatestDeliveryNotes');

export const useGetLatestDeliveryNotes = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_LATEST_DELIVERY_NOTES, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getLatestDeliveryNotes || []);
        }
    }, [data]);

    return {
        latestDeliveryNotes: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
